import type { ShouldHideAppLoaderParams } from './interfaces/shouldHideAppLoaderParams.interface'
import { shouldBypassAppLoader } from './shouldBypassAppLoader'

export function shouldHideAppLoader({ isLoading, pathname, showOnSettings }: ShouldHideAppLoaderParams): boolean {
  if (!isLoading || shouldBypassAppLoader(pathname)) {
    return true
  }

  const isSettingsRoute = pathname?.includes('/settings') ?? false
  return isSettingsRoute && !showOnSettings
}
